// Fachada para mantener los imports existentes en tu código.
// Internamente usa articuloService (mismo endpoint).

import {
  obtenerArticulos,
  crearArticulo,
  actualizarArticulo,
  eliminarArticulo,
  buscarArticuloPorClave,
  normalizarArticulo,
  obtenerArticuloPorId,
  obtenerArticuloDetalle,
} from "./articuloService";

// Alias con los nombres que ya usa tu app
export const obtenerProductos       = obtenerArticulos;
export const crearProducto          = crearArticulo;
export const actualizarProducto     = actualizarArticulo;
export const eliminarProducto       = eliminarArticulo;
export const buscarProductoPorClave = buscarArticuloPorClave;

// Por si los necesitas en otros lados
export {
  normalizarArticulo as normalizarProducto,
  obtenerArticuloPorId as obtenerProductoPorId,
  obtenerArticuloDetalle as obtenerProductoDetalle,
};

// Default (por compatibilidad con tu export default previo)
const productoService = {
  obtenerProductos,
  crearProducto,
  actualizarProducto,
  eliminarProducto,
  buscarProductoPorClave,
};
export default productoService;
